export default __webpack_public_path__ + "static/media/pot3.0db4467d.png";